import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import PopoverArrow from "./PopoverArrow";
import cn from "../../../utils/cn";
const PopoverContent = ({ className, portal = true, align = "center", showArrow = true, arrowClassName, offset = "icon", children, ...props }) => {
    const alignOffset = align === "start" ? -20 : align === "end" ? 20 : 0;
    const iconOffset = offset === "icon" ? -4 : 0;
    const buttonOffset = offset === "button" ? 0 : 0;
    const textOffset = offset === "text" ? -8 : 0;
    const sideOffsetNumber = typeof offset === "number" ? offset : 0;
    const WrapperPortal = portal ? PopoverPrimitive.Portal : React.Fragment;
    return (_jsx(_Fragment, { children: _jsx(WrapperPortal, { children: _jsxs(PopoverPrimitive.Content, { align: align, sideOffset: showArrow ? iconOffset + buttonOffset + textOffset + sideOffsetNumber : 5, collisionPadding: 16, sticky: "always", alignOffset: alignOffset, className: cn([
                    "p-4",
                    "z-10",
                    "rounded-lg",
                    "border",
                    "bg-white",
                    "border-gray-4",
                    "shadow-md",
                    "will-change-[transform,opacity]",
                    "data-[state=open]:data-[side=top]:animate-slide-down-and-fade",
                    "data-[state=open]:data-[side=right]:animate-slide-left-and-fade",
                    "data-[state=open]:data-[side=bottom]:animate-slide-up-and-fade",
                    "data-[state=open]:data-[side=left]:animate-slide-right-and-fade",
                ], className), ...props, children: [children, showArrow ? _jsx(PopoverArrow, { className: arrowClassName }) : null] }) }) }));
};
PopoverContent.displayName = PopoverPrimitive.Content.displayName;
export default PopoverContent;
